import React from 'react';

export default function success() {
  return (
    <div className="success">
      <h2>You're In!</h2>
      <p>We'll notify you via email when it's time to shop
      </p>
      <a href="https://tommyjohn.com" className="button red short">Shop New Arrivals</a>
    </div>
  )
}
